import * as React from 'react'
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export'
import { MarginLeftButton } from '../../common/styled'


class ExcelComponent extends React.Component {
    _exporter;
    export = () => {
        this._exporter.save();
    }

    render() {
        const data = this.props.connections;
        return (
            <span>
                <MarginLeftButton
                    icon="download"
                    type="primary"
                    title="Download Excel ordine"
                    onClick={this.export}>Esporta Excel</MarginLeftButton>

                <ExcelExport
                    data={data}
                    fileName="Products.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }}
                >
                    <ExcelExportColumn field="refLm" title="Ref. LM" />
                    <ExcelExportColumn field="description" title="Descrizione Prodotto" />
                    <ExcelExportColumn field="shippedStock" title="Quantità Spedita" />
                </ExcelExport>
            </span>
        );
    }
}

export default ExcelComponent




// WEBPACK FOOTER //
// ./src/components/ExcelComponent/index.js